<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("ORGANIZATIONS.ADD_ORGANIZATION") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <organization-form
              :loading="loading"
              :organizationData="organization"
              :formErrors="formErrors"
              @organizationSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultOrganization from "./defaultOrganization";
import OrganizationForm from "./partials/OrganizationForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    OrganizationForm,
  },

  mixins: [alertLeave],

  data() {
    const organization = cloneDeep(defaultOrganization);
    return {
      organization: organization,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List Organizations" });
    },

    viewOrganization(organization) {
      this.alertLeave = false;
      this.$router.push({
        name: "View Organization",
        params: { id: organization.id },
      });
    },

    async handleSubmit(organization) {
      this.loading = true;

      const organizationData = cloneDeep(organization);
      delete organizationData.id;
      if (this.$currentUserIsLevelReseller()) {
        organizationData.reseller.id = this.$currentUserResellerId();
      }

      try {
        await this.$store.dispatch("organizations/add", organizationData);
        this.$notify({
          type: "success",
          message: this.$t("ORGANIZATIONS.ORGANIZATION_ADDED"),
        });
        const organization = await this.$store.getters[
          "organizations/organization"
        ];
        this.viewOrganization(organization);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const organization = await this.$store.getters[
          "organizations/organization"
        ];
        if (organization.id) {
          await this.$store.dispatch("organizations/destroy", organization.id);
        }
        this.loading = false;
      }
    },
  },
};
</script>
